import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faPlay, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Movie({ movie, handleMovieClick, isActive, movieFocus }) {
	const base_url = "https://image.tmdb.org/t/p/original";

	function truncate(str, n) {
		return str?.length > n ? str.substr(0, n - 1) + "..." : str;
	}

	return (
		<div
			onClick={() => movieFocus(movie)}
			className={`movie-item ${isActive ? " movie-item-big" : ""}`}
		>
			<div className="movie-img">
				<div className="movie-rating">
					{movie.vote_average?.toFixed(1)}{" "}
					<FontAwesomeIcon icon={faStar} style={{ fontSize: '10px' }} />
				</div>
				<img
					className="row__poster row__posterLarge"
					src={`${base_url}${movie.poster_path}`}
					alt={movie?.title || movie?.name || movie?.original_name}
					loading="lazy"
				/>
			</div>

			<div className="movie-data">
				<h3>{movie.title || movie?.name || movie?.original_name}</h3>
				<p>{truncate(movie?.overview, 150)}</p>
				<div>
					<button
						className="banner__button banner__button--primary"
						onClick={(e) => {
							handleMovieClick(movie);
							e.stopPropagation();
						}}
					>
						<FontAwesomeIcon icon={faPlay} />
						Trailer
					</button>
					<Link
						to={`/movie/${movie.id}`}
						className="banner__button banner__button--secondary"
						onClick={(e) => e.stopPropagation()}
					>
						<FontAwesomeIcon icon={faInfoCircle} />
						Details
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Movie;
